import { useCallback, useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAutoloadClientActions, useAutoloadClientList } from "../../api/autoload/AutoloadClientsApi";
import { SessionContext } from "../../common/contexts/SessionContext";
import { LucideIcon } from "../../common/icon/LucideIcon";
import { StepwiseWizard, StepwiseWizardComponentProps } from "../../common/StepwiseWizard/StepwiseWizard";
import ContentRow from "../../common/tables/ContentRow/ContentRow";
import { getAddRoute, getIndexRoute } from "../../main/Routing";
import styles from "./BridgeClientWizard.module.css";
import { dataSourceConstants } from "../../api/DataSource";
import { Bridge, BridgeFilters, bridgeConstants } from "../../api/Bridges";
import { DateTimeRenderer } from "../../common/datetime/DateTimeFormatter";
import { AutoloadClientOsType, getAutoloadClientDownloadURL } from "../common/AutoloadUtils";
import { FormFieldLayout } from "../../common/formfields/FormFieldLayouts";
import { LoadingWrapper } from "../../common/LoadingWrapper";
import { BridgeContentRow } from "../DataSources/DataSourceForm";
import { EntityList } from "../../common/lists/EntityList";
import { useQueryClient } from "@tanstack/react-query";
import { DataSourceAddFormPage } from "../DataSources/DataSourceViews";
import { Button } from "../../common/buttons/Button/Button";
import { showtoast } from "../../common/overlays/Toasts/showtoast";
import { PageNotAllowed } from "../../main/common/PageNotAllowed/PageNotAllowed";
import { OverlayInfo } from "../../common/misc/OverlayInfo/OverlayInfo";
import { useListen } from "../../common/signalr/SignalRContext";

const linux_svg = (
  <svg xmlns="http://www.w3.org/2000/svg" width="2500" height="2500" viewBox="0 0 192.756 192.756">
    <g fillRule="evenodd" clipRule="evenodd">
      <path fill="none" d="M0 0h192.756v192.756H0V0z" />
      <path d="M104.396 10.712c.984-.042 1.99.244 2.969.335 1.637.351 3.301.819 4.85 1.483.979.405 1.84 1.085 2.834 1.415 1.336.675 2.244 1.883 3.504 2.632.867.904 1.59 1.51 2.426 2.425.43.532.809 1.011 1.213 1.553.164.681.809 1.175 1.01 1.882.346.787.666 1.654.809 2.563.234 1.026.463 2.063.473 3.1-.148 8.036-.25 16.081 0 24.132.41 2.372.191 4.845.879 7.142.346 1.717.6 3.478 1.344 4.855 1.283 2.303 2.293 4.759 3.713 7.078.781.846 1.387 1.792 2.154 2.696 1.535 2.202 2.818 4.775 4.451 6.807 1.047 2.095 2.189 4.143 3.365 6.201.877 2.643 2.383 5.067 3.037 7.817.865 3.096 1.824 6.137 2.291 9.572 1.006 5.439 1.713 10.832 2.355 16.311-.037 2.961-.408 5.934-.266 8.896-.271.994-.084 1.961-.34 2.967-.314 1.393-1.117 2.67-1.414 4.047.121.771-.277 1.51-.133 2.291.633 1.293.68 2.777 1.01 4.176.527.318.803.951 1.414 1.352 1.043-.193 2.047.303 3.102.133 1.254-.336 2.562-.309 3.775-.537 1.488-.166 2.951.281 4.445.133.973.615 2.1 1.084 2.967 1.686.777.463 1.102 1.457 1.889 2.021-.271 1.322.031 2.711-.336 3.977-1.361 1.883-2.541 3.936-3.844 5.797-2.197 2.191-3.951 4.791-6.068 7.078-2.574 2.652-4.85 5.525-7.477 8.156-3.084 1.766-5.355 4.547-8.291 6.537-1.318.578-2.377 1.631-3.775 1.887-1.16.361-2.436.586-3.643.74h-3.164c-.984-.336-2.084-.379-3.037-.74-.611-.355-1.281-.51-1.887-.807-1.123-.645-1.926-1.639-2.963-2.363-.244-.707-.883-1.217-1.352-1.818-.547-1.207-1.111-2.414-1.414-3.705-.006-.629-.229-1.176-.336-1.756-2.594.213-5.215.266-7.82.543-2.697-.139-5.398-.166-8.09-.139-3.504-.506-7.014-.67-10.513-1.414-2.495-.57-4.962-1.107-7.414-1.889-1.829-.793-3.754-1.441-5.525-2.223-.276-.41-.877-.457-1.149-.809-.867.713-1.356 1.766-2.223 2.627-.606 1.611-1.659 3.025-2.494 4.521-.346.414-.856.812-.877 1.344-.724.602-1.261 1.213-1.958 1.889-1.303.506-2.452 1.414-3.84 1.547-.351.441-1.26-.031-1.617.41-1.196.281-2.388-.309-3.573-.07-1.446-.648-3.042-1.078-4.382-1.754-2.419-1.373-4.834-2.723-7.28-3.979a431.506 431.506 0 0 1-14.422-11.188c-1.484-1.479-2.967-2.963-4.451-4.445-.404-1.182-.819-2.324-1.074-3.506.303-.85.596-1.627.809-2.494.409-.365.792-.92 1.212-1.281.532-1.084 2.011-1.133 2.968-1.617 1.096-.371 2.148-.346 3.233-.541 1.308-.006 2.266-.734 3.372-.941.101-.404.409-.648.537-1.08.255-1.414-.404-2.834-.271-4.244.324-.803.564-1.59.877-2.43.224-.59.851-1.186 1.351-1.479.394-.139.49-.51 1.011-.473a17.114 17.114 0 0 1 3.233 0c1.01.361 2.031.707 3.031 1.143.494.244 1.255.096 1.888.139.617-.404.941-1.346 1.553-1.686a20.75 20.75 0 0 1 2.829-4.516c.324-.143.394-.479.744-.541.479-.271.304-.969.335-1.213-.505-3.271-.096-6.562-.133-9.844.261-2.611.542-5.285 1.011-7.816.457-2.367 1.096-4.719 1.547-7.078.979-2.836 2.228-5.67 3.303-8.425 5.312-10.79 11.332-21.202 16.921-31.811 1.042-1.484 1.792-3.143 2.829-4.584v-.271c-.181-1.404.473-2.818.271-4.18V43.468c-.276-2.425-.048-4.861-.271-7.28-.043-.271-.096-.537-.133-.808v-6.876c.197-.053.106-.175.133-.266-.176-.675.297-1.154.133-1.824.361-.771.526-1.669.675-2.494a19.163 19.163 0 0 1 3.101-4.647c1.148-1.165 2.42-2.117 3.643-3.169 1.643-1.335 3.531-2.324 5.392-3.303 1.244-.404 2.318-1.101 3.771-1.346 1.696-.541 3.51-.775 5.258-.743z" />
      <path
        d="M111.949 36.866c.812.516 1.541 1.127 2.424 1.616.676 1.511-.025 3.143.133 4.717-.732 1.968-1.238 4.281-3.232 5.393-1.176.016-2.393-.431-3.504-.808 1.037-.357 2.494-.883 2.967-2.154.59-.883.893-1.926.941-2.968-.096-1.239-.33-2.547-1.08-3.573a4.66 4.66 0 0 0-2.424-1.483c-1.559-.293-2.762.691-3.506 1.686-.371.733-.754 1.483-.877 2.292-.309 1.729.336 3.542 1.143 4.989-.686-.729-1.967-.803-2.355-1.75-1.121-2.558-1.074-5.451-.068-7.955 3.051-1.013 6.374-1.204 9.438-.002zM91.05 36.796c.638.479 1.622.346 2.159 1.01a12.79 12.79 0 0 1 .537 7.685c-.734-.038-1.361 1.282-1.75.675.83-1.92.803-4.238-.335-6.068-.59-.766-1.398-1.574-2.361-1.617-.724.309-1.511.377-2.021 1.08-1.175 1.362-1.33 3.302-1.212 4.988.255 1.691 1.35 3.196 2.898 3.909-.712.399-1.382.739-2.159.941-.983-1.186-1.494-2.659-1.957-4.111-.644-2.09-.277-4.186-.266-6.27.771-.872 1.771-1.516 2.83-1.952.829-.599 2.525-.275 3.637-.27zM112.486 59.78c.861 2.511 1.334 5.105 2.02 7.685.803 2.866 2.234 5.488 3.303 8.227 1.176 2.234 2.33 4.478 3.303 6.871.043.096.096.175.139.271 2.344 5.095 4.648 10.179 7.008 15.3 1.447 3.818 2.756 7.658 3.777 11.662.084 2.035.936 4.004.67 6.066-1.086 3.877-1.883 7.865-3.234 11.662-.314.707-.562 1.441-1.143 1.953-.277-.006-.266.275-.543.27-.543.475-.984 1.012-1.281 1.688a12.295 12.295 0 0 0-.67 4.109c-.602-.074-1.01-.457-1.484-.744-.994-.256-1.945-.596-2.967-.809-1.17.145-3.281-.713-3.637.746-.549.711-1.006.939-1.484 1.686a101.772 101.772 0 0 0-1.213 11.252c.133 2.51-.287 5.031-.139 7.551-1.643 1.09-3.482 1.867-5.391 2.494-1.475.463-2.898 1.016-4.719 1.08-1.615.26-3.27.281-4.85.537-2.43.127-4.86.016-7.279.068-1.755-.195-3.675-.543-5.259-.676-3.398-.77-6.749-1.689-9.838-3.371.053-1.195.697-2.531.266-3.84-1.787-5.029-4.286-9.762-6.333-14.693-1.829-4.658-3.238-9.459-5.058-14.086-1.121-2.389-2.153-4.809-2.967-7.281-.463-.633-.005-1.387.138-2.025.665-3.402 2.148-6.455 3.372-9.705 2.015-4.031 3.792-8.173 6.2-11.997 1.186-1.973 1.138-4.265 1.819-6.403.792-2.6 2.117-4.913 3.233-7.343 1.675-2.66 2.893-5.558 4.515-8.227 1.436-2.973 2.462-6.328 3.978-9.029.936.856 1.952 1.542 2.898 2.425 1.287.622 2.659 1.26 4.11 1.212 1.979.298 3.952.011 5.934 0 2.67-.441 5.33-1.042 7.686-2.355 1.67-.846 3.264-1.957 4.918-2.632.07.135.132.268.202.401zM63.014 97.393c.037-.133.095-.271.133-.404-.038.132-.096.271-.133.404zM62.206 99.957v-.139.139z"
        fill="#fff"
      />
      <path
        d="M98.936 43.741c.799.25 1.707.33 2.361.809.203.373.682.612.809 1.01 2.691 1.478 5.318 3.005 8.359 3.637 1.414-.165 2.803.436 4.041 1.149.346.431.719.776 1.08 1.144.164.974.814 1.749.475 2.898-.24.579-.311 1.319-.746 1.755-.611.531-.867 1.281-1.547 1.749-2.76 1.276-5.133 3.116-8.02 4.249-3.016 1.313-6.818 1.617-10.652 1.818-1.105-.196-2.292-.186-3.302-.537-.745-.175-1.463-.675-2.09-.947-1.687-1.441-3.67-2.585-4.988-4.445-.075-.58-.437-.702-.606-1.213-.531-.898-.447-2.85-.069-3.845.054-.638.58-1.154.676-1.686 2.148-1.489 4.669-2.181 6.807-3.638 1.053-1.415 3.037-1.781 4.047-3.1 1.105-.291 2.179-1.221 3.365-.807z"
        fill="#e7bf5d"
      />
      <path d="M112.082 55.196c-1.346 1.41-3.232 1.75-4.988 2.361-4.229.702-8.451 1.25-12.672 1.483a47.544 47.544 0 0 1-5.392 0c-1.192-.196-2.356-.771-3.372-1.414-.505-.627-1.276-1.208-1.345-2.026 1.436.611 2.159 2.356 3.908 2.494 3.681.713 7.365.117 11.055-.133 4.355-.372 9.136-1.558 12.806-2.765z" />
      <path
        d="M82.291 28.506c.038-.09.09-.175.133-.266-.027.091.064.213-.133.266zM110.125 32.415c.537.117.852.681 1.42.675.605.648 1.148 1.34 1.75 2.021.223 1.153 1.201 2.116 1.078 3.371-.883-.489-1.611-1.101-2.424-1.616-3.064-1.202-6.387-1.011-9.439 0 .09-.75.775-1.335.945-2.021.746-1.074 1.879-1.888 3.102-2.361 1.084-.681 2.392-.261 3.568-.069zM89.433 33.43c.516.144.835.665 1.351.739.644.756 1.409 1.42 1.888 2.292.356.377.255.967.537 1.345-.537-.665-1.521-.532-2.159-1.01-1.112-.006-2.808-.33-3.637.271-1.059.436-2.059 1.08-2.83 1.952v-.941a13.45 13.45 0 0 1 1.213-3.233c.611-.394.867-1.08 1.617-1.282.43-.346 1.451-.197 2.02-.133zM82.424 36.19c-.133-.271-.133-.537-.133-.808.038.271.09.537.133.808zM82.424 59.514c-.133-.096-.133-.176 0-.271v.271zM121.25 82.833c-.043-.095-.096-.175-.139-.271.198-.006.112.175.139.271zM64.226 94.293c.043-.096.096-.175.133-.271-.037.096-.09.175-.133.271zM94.692 100.291c.133.734.085 1.611.271 2.223-.925 5.559-1.547 11.088-2.09 16.715-.516 4.627-.377 9.27-1.148 13.891-.133.404-.431.941-.877 1.211-.383.092-.596-.127-.74-.34-.234-.494-.479-.867-.473-1.547-.276-1.006-.106-1.979-.133-2.967.175-6.223.867-12.428 1.617-18.602.5-3.303.713-6.627 1.755-9.844a2.15 2.15 0 0 1 .809-1.074c.255-.064.309-.191.606-.139.132.164.271.309.403.473z"
        fill="#c6c7c9"
      />
      <path
        d="M61.195 129.344c.712.26 1.148.92 1.819 1.281.659 1.627 1.569 3.025 2.223 4.646 1.973 5.139 3.611 10.359 5.259 15.641.127.889.542 1.611.67 2.559.165 4.105 1.288 8.131 1.351 12.268-.208 1.01.175 2.398-.335 3.17-.41 1.643-1.229 2.998-2.026 4.514-.84.771-1.51 1.654-2.696 1.957-.612.367-1.341.639-2.154.809-1.463.438-3.372.568-5.126.404-1.239-.457-2.558-.818-3.771-1.281-2.669-1.643-5.52-3-8.227-4.451-4.515-3.562-9.227-7.047-13.613-10.646-1.617-1.643-3.234-3.275-4.855-4.918-.208-.941-.564-1.9-.941-2.766.298-1.021.803-1.979 1.08-2.969.436-.328.904-.859 1.212-1.143 1.069-.398 2.085-1.01 3.233-1.08 1.207-.33 2.792-.143 3.908-.676.841-.461 2.117-.473 2.431-1.482.106-.436.276-.734.537-1.08-.074-.867-.33-1.754-.335-2.627-.064-.531-.213-1.5.133-1.887-.005-.904.761-1.611.877-2.426.447-.244.803-.602 1.345-.738.718.057 1.309-.4 2.027-.139.712.117 1.446-.006 2.153.404.734.445 1.76.371 2.431.945.521.129 1.117.037 1.68.064.846-.682 1.249-1.543 2.09-2.223.569-1.08 1.106-2.176 1.824-3.17.356-.541.771-1 1.212-1.479.628-.238 1.006-.771 1.617-.945.829-.49 1.786-.803 2.765-.809 0 .177.165.107.202.273zM122.596 134.938c.596.037 1.232.361 1.754.469.404.211.645.67 1.213.674.201 1.602-.234 3.24.201 4.855.154.738.537 1.463.879 2.09.84 1.074 2.18 1.596 3.164 2.494 1.291.58 2.557 1.314 3.977 1.547 1.15.305 3.074.607 4.18 0 .336-.275.852-.404 1.15-.605.834-.76 1.402-1.648 2.09-2.494.914-2.111 2.084-4.096 3.1-6.131.377.148.457.6.809.809 1.047 1.611.58 3.785 1.748 5.322.518.33.82 1.053 1.484 1.08.932.17 2.074-.068 2.898.201 2.695-.559 5.479-.674 8.223-.404.871.213 1.68.879 2.492 1.08.676.664 1.25 1.516 1.889 2.154.021 1.285-.027 2.611-.404 3.844-1.43 2.049-2.627 4.121-4.041 6.131-2.457 2.326-4.51 5.154-6.605 7.686-1.83 1.596-3.25 3.686-4.855 5.393-.633.58-1.291 1.084-1.887 1.754-.84.379-1.34 1.17-2.225 1.479-1.68 1.559-3.6 2.729-5.189 4.451-1.01.42-1.967 1.059-2.967 1.553-2.293.82-4.76 1.186-7.143 1.145-1.223-.463-2.568-.188-3.775-.879-.643-.387-1.426-.562-2.021-1.01-1.26-.967-2.361-2.143-3.371-3.371-.484-.707-.707-1.352-1.01-2.154-1.021-4.281-1.83-8.566-2.766-12.875.068-4.961-.17-10.178.201-14.895.197-1.404-.127-3.121.273-4.312.158-1.941.711-3.871.875-5.797.639-.426.943-1.08 1.48-1.621 1.392.108 3.173-.281 4.179.337zM72.789 159c1.196 1.01 2.823 1.479 3.435 3.102.191.51.474 1.158.404 1.75-1.255 1.658-3.244 2.893-3.637 5.125.404-3.424-.042-6.85-.675-10.248.083.128.424.058.473.271z"
        fill="#e7bf5d"
      />
      <path
        d="M63.014 97.393c-.027.107-.043.229-.069.336.026-.108.042-.229.069-.336zM62.206 99.957c-.042.09-.096.17-.341.393.245-.223.298-.303.341-.393zM62.875 97.797c-.027.107-.037.229-.064.336.027-.108.038-.229.064-.336zM62.945 97.729l-.069.068.069-.068zM62.743 98.201c-.026.107-.042.229-.069.336.026-.107.042-.228.069-.336zM62.812 98.133l-.069.068.069-.068zM61.397 102.244v0zM62.61 98.605c-.027.107-.043.229-.069.336.026-.107.042-.228.069-.336zM62.674 98.537c-.027.025-.038.041-.064.068.026-.027.037-.043.064-.068z"
        fill="#fff"
      />
      <path
        d="M61.259 107.572c-.064 0 .042.631.101 1.287.069-.043.102.574.069 1.232-.106-.676-.196-1.297-.17-1.238-.038-.123-.112-.58-.149-.941-.08-.367-.148-.941-.085-.553-.127-.586.037-1.426.053-2.123.048-.303.042-.025.202-2.244.256-1.689.756-3.451 3.021-8.854-2.297 6.148-2.542 7.143-2.515 7.338-.154.363-.261 1.607-.335 2.447-.097.686-.251 2.495-.192 3.649zM131.832 83.982c-.043.037-.096.09-.139.133.043-.043.096-.096.139-.133z"
        fill="#fff"
      />
      <path
        d="M134.123 91.464c.709 1.893.746 4.11.873 5.928.262 3.229-.006 6.473 0 9.705-.516 5.398-1.25 10.828-2.424 16.178-.102.723-.635 1.254-.809 1.889-.133.148-.271.148-.404 0 .127-.447.398-.729.537-1.15.695-3.09 1.25-6.252 1.824-9.363.377-2.414.43-4.83.605-7.217l.133-.133c-.18-1.686.303-3.377.133-5.057.197-.133.111-.361.139-.537.133-2.293-.389-4.59-.271-6.877-.105-1.904-.967-3.691-1.143-5.525-.271-1.809-1.08-3.478-3.488-9.95 1.961 4.829 2.041 4.893 2.057 4.909.309.941.883 1.702 1.027 2.616.506 1.361.908 3.074 1.211 4.584zM62.471 99.01c-.026.105-.037.229-.063.336.026-.108.037-.231.063-.336zM62.541 98.941c-.026.025-.042.043-.069.068l.069-.068zM62.408 99.346c-.027.031-.042.041-.069.068.026-.027.042-.037.069-.068z"
        fill="#fff"
      />
    </g>
  </svg>
);
const microsoft_svg = (
  <svg
    width="2490"
    height="2500"
    viewBox="0 0 256 257"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid"
  >
    <path
      d="M0 36.357L104.62 22.11l.045 100.914-104.57.595L0 36.358zm104.57 98.293l.08 101.002L.081 221.275l-.006-87.302 104.494.677zm12.682-114.405L255.968 0v121.74l-138.716 1.1V20.246zM256 135.6l-.033 121.191-138.716-19.578-.194-101.84L256 135.6z"
      fill="#00ADEF"
    />
  </svg>
);

const useClientInstallation = () => {
  const { api, route, session } = useContext(SessionContext);
  const [disableTLS, setDisableTLS] = useState<boolean>(false);
  const [showAdvancedOptions, setShowAdvancedOptions] = useState<boolean>(false);
  const platform = navigator?.platform || "unknown"; // Might need let platform = navigator?.userAgentData?.platform || navigator?.platform in the future
  const isWin64 = navigator.userAgent.indexOf("WOW64") !== -1 || navigator.userAgent.indexOf("Win64") !== -1;
  const curr_os = platform.includes("Win")
    ? isWin64
      ? "win"
      : "win32"
    : platform.includes("Linux")
      ? "linux"
      : undefined;
  const [os, setOS] = useState<AutoloadClientOsType | undefined>(curr_os);

  const validate = useCallback(() => {
    return os !== undefined;
  }, [os]);

  return {
    validate: validate,
    body: () => (
      <>
        <div className={styles.col}>
          <div className={styles.label_descriptor}>Step 1: Install client</div>
          <div className={`${styles.col}`}>
            <span style={{ color: "var(--gray-600)" }}>
              <p></p>
              <strong>Instructions:</strong>
              <ol className={styles.instructions} type="a">
                <li>
                  Download the client for the OS of the instrument PC.
                  <div className={styles.row}>
                    <div className="flex col-nowrap align-center gap-5" style={{ width: "100%", height: "100%" }}>
                      <div className={styles.os_module}>
                        {microsoft_svg}
                        <span>
                          {`>`} Windows 10
                          <sup>*</sup>
                        </span>
                      </div>
                      <div className="flex row-nowrap align-center gap-5" style={{ width: "100%" }}>
                        <a
                          className="btn btn-primary btn-block"
                          style={{ margin: 0, textDecoration: "none" }}
                          onClick={() => setOS("win32")}
                          href={getAutoloadClientDownloadURL("win32", disableTLS, api)}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <LucideIcon name="download" /> 32 bit
                        </a>
                        <a
                          className="btn btn-primary btn-block"
                          style={{ margin: 0, textDecoration: "none" }}
                          onClick={() => setOS("win32")}
                          href={getAutoloadClientDownloadURL("win", disableTLS, api)}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <LucideIcon name="download" /> 64 bit
                        </a>
                      </div>
                    </div>
                    <div className="flex col-nowrap align-center gap-5" style={{ width: "100%", height: "100%" }}>
                      <div className={styles.os_module}>
                        {linux_svg}
                        <span>{`≥ AlmaLinux 9.0, ≥ Ubuntu 16.04, ≥ CentOS 7`}</span>
                      </div>
                      <div className="flex row-nowrap align-center gap-5" style={{ width: "100%" }}>
                        <a
                          className="btn btn-primary btn-block"
                          style={{ margin: 0, textDecoration: "none" }}
                          onClick={() => setOS("linux")}
                          href={getAutoloadClientDownloadURL("linux", disableTLS, api)}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <LucideIcon name="download" /> 64 bit
                        </a>
                      </div>
                    </div>
                  </div>
                  <div style={{ marginTop: "10px" }}>
                    <button
                      type="button"
                      className="btn btn-link"
                      style={{ padding: 0, fontSize: "inherit" }}
                      onClick={() => setShowAdvancedOptions((prev) => !prev)}
                    >
                      {showAdvancedOptions ? "Hide advanced download options" : "Show advanced download options"}
                    </button>
                    {showAdvancedOptions && (
                      <div className={"flex col-nowrap gap-5"} style={{ marginLeft: "20px" }}>
                        <div className="flex row-nowrap align-center gap-5">
                          <label>
                            <input
                              type="checkbox"
                              checked={disableTLS}
                              onChange={(e) => setDisableTLS(e.target.checked)}
                            />{" "}
                            Disable TLS validation
                          </label>
                          <OverlayInfo icon="info">
                            Disables TLS validation for the client. This is only recommended if you are using a
                            non-standard configuration.
                          </OverlayInfo>
                        </div>
                      </div>
                    )}
                  </div>
                  The downloaded archive contains the client executable and a configuration file.
                </li>

                <li>
                  Install the client by extracting the archive and running the installer <p />
                  <span style={{ color: "var(--gray-400)" }}>
                    For the installation, executable and configuration file have to be in the same directory. <p />
                    This will update already existing clients.
                  </span>
                </li>
              </ol>
            </span>
            <span style={{ color: "var(--gray-400)", fontSize: "0.8em" }}>
              <sup>*</sup>Windows 7 (fully patched SP1) has been tested, but is not officially supported.
            </span>
            {!session?.features.enable_legacy_SFTP_autoloads && (
              <>
                <hr style={{ margin: 0, marginBottom: "10px", borderColor: "var(--gray-200)" }} />
                <div className="flex row-nowrap gap-5 align-center">
                  <span style={{ color: "var(--info)", fontWeight: "bold" }}>
                    <LucideIcon name="info" /> OS not supported?{" "}
                  </span>
                  <Link to={route(`${getIndexRoute(bridgeConstants.frontendIndexRoute)}/sftp_wizard`)}>
                    Set up a bridge using SFTP instead.
                  </Link>
                </div>
              </>
            )}
          </div>
        </div>
      </>
    ),
  };
};

const ApproveClientsForm = (props: StepwiseWizardComponentProps) => {
  const { route } = useContext(SessionContext);
  const { refetch, data: clients, status, fetchStatus, error } = useAutoloadClientList();
  const { approveClient } = useAutoloadClientActions();

  useListen("ClientListUpdated", refetch);

  const queryClient = useQueryClient();

  useEffect(() => {
    refetch();
  }, [refetch]);

  return (
    <div className={`${styles.col}`}>
      <div className={styles.label_descriptor}>Step 2: Connect new client</div>

      <LoadingWrapper status={status} fetchStatus={fetchStatus} error={error}>
        {!!clients?.length && (
          <>
            <hr style={{ margin: "20px 0", borderColor: "var(--gray-200)" }} />
            <FormFieldLayout id="" label="Available clients" horizontal>
              <div style={{ maxHeight: "50vh", overflow: "auto" }}>
                {clients?.map((client, index) => (
                  <div style={{ marginBottom: "2px" }} key={index}>
                    <ContentRow
                      icon={<LucideIcon name={bridgeConstants.icon} />}
                      label={client.host}
                      date={
                        <div className="flex row-nowrap align-center gap-5" style={{ minWidth: "max-content" }}>
                          <span style={{ fontSize: "12px" }}>First seen:</span>{" "}
                          <DateTimeRenderer date={client.firstSeen} includeElapsed={false} />
                        </div>
                      }
                      id={`Client Version: ${client.clientVersion}`}
                      info={`IP-Address: ${client.ipAddress}`}
                      controls={
                        <div style={{ padding: "0 10px" }}>
                          <button
                            className="btn btn-xs btn-primary flex align-center gap-5"
                            onClick={async () => {
                              if (!client.isApproved) {
                                approveClient(client.id)
                                  .then(() => {
                                    refetch();
                                    queryClient.invalidateQueries({ queryKey: [bridgeConstants.resource, "list"] });
                                  })
                                  .catch((e) => {
                                    showtoast("error", "An error occurred while approving the client.");
                                    console.error(e);
                                  });
                              }
                            }}
                          >
                            <LucideIcon name="circle-check-big" />
                            Approve
                          </button>
                        </div>
                      }
                    />
                  </div>
                ))}
              </div>
            </FormFieldLayout>
          </>
        )}
      </LoadingWrapper>

      <hr style={{ margin: 0, marginBottom: "20px", borderColor: "var(--gray-200)" }} />

      <FormFieldLayout id="" label="Unconfigured clients" horizontal>
        <div style={{ minHeight: "200px", height: "25vh", overflow: "auto" }}>
          <EntityList<Bridge, BridgeFilters>
            entityConstant={bridgeConstants}
            filters={{ isConfigured: false, types: ["Client"] }}
            rowRenderer={(b) => (
              <div className="flex align-center gap-5" key={b.id}>
                <BridgeContentRow bridge={b} />
                <Button
                  onClick={() => props.nextHandle({ bridgeId: b.id.toString() })}
                  className="btn btn-primary btn-xs flex align-center gap-5"
                >
                  <LucideIcon name={dataSourceConstants.icon} />
                  Configure data source
                </Button>
              </div>
            )}
            rowHeight={56}
            noItemMessage="There are no unconfigured clients."
          />
        </div>
      </FormFieldLayout>

      <hr style={{ margin: 0, marginBottom: "20px", borderColor: "var(--gray-200)" }} />

      <div className="flex row-nowrap gap-5 align-center">
        <span style={{ color: "var(--info)", fontWeight: "bold" }}>
          <LucideIcon name="info" /> Bridge already configured?
        </span>
        <Link to={route(`${getAddRoute(dataSourceConstants.frontendIndexRoute)}`)}>
          Add another data source configuration to existing bridges.
        </Link>
      </div>
    </div>
  );
};

export const BridgeClientWizard = () => {
  const { session } = useContext(SessionContext);
  const { validate: validateOs, body: osBody } = useClientInstallation();

  if (!session?.permissions.administer_autoload) return <PageNotAllowed />;

  return (
    <StepwiseWizard
      title={"Bridge setup wizard"}
      steps={[
        { label: "Install client", validatefn: validateOs, component: osBody },
        {
          label: "Connect new client",
          validatefn: () => true,
          component: (props) => <ApproveClientsForm {...props} />,
          hideNextButton: true,
        },
        {
          label: "Configure data source",
          validatefn: () => true,
          hideNextButton: true,
          hidePrevButton: true,
          component: () => (
            <div className="center-horizontally">
              <DataSourceAddFormPage />
            </div>
          ),
        },
      ]}
    />
  );
};
